import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { showDialog } from '../../../core/actions';
import { selectUserGroup } from '../../../store/authReducer';
import * as actions from '../actions';
import { selectPage, selectPageSize, selectTotal, selectUtilities } from '../utilityReducer';
import UtilityDataGetter from '../components/UtilityDataGetter';

export const Utilities = (props) => {
  return <UtilityDataGetter {...props} />;
};

const mapStateToProps = (state) => {
  return {
    utilities: selectUtilities(state),
    total: selectTotal(state),
    userGroup: selectUserGroup(state),
    pageInfo: {
      total: selectTotal(state),
      page: selectPage(state),
      pageSize: selectPageSize(state),
    },
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showDialog,
      ...actions,
    },
    dispatch
  );

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl, withRouter);

export default enhance(Utilities);
